import React, { useState } from "react";

const s = {
  page: {
    minHeight: "100vh", background: "#080c18", display: "flex",
    alignItems: "center", justifyContent: "center", fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "#0d1224", border: "1px solid #1e2a45", borderRadius: "12px",
    padding: "40px", width: "380px", boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
  },
  title: { fontSize: "22px", fontWeight: 700, color: "#60a5fa", textAlign: "center", marginBottom: "4px" },
  sub: { fontSize: "11px", color: "#475569", textAlign: "center", marginBottom: "28px" },
  label: { fontSize: "12px", color: "#94a3b8", marginBottom: "4px", display: "block" },
  input: {
    width: "100%", padding: "10px 12px", borderRadius: "6px", border: "1px solid #1e2a45",
    background: "#0a0f1e", color: "#e2e8f0", fontSize: "14px", marginBottom: "16px",
    outline: "none", boxSizing: "border-box",
  },
  btn: (disabled) => ({
    width: "100%", padding: "11px", borderRadius: "6px", border: "none",
    background: disabled ? "#1e2a45" : "#1e40af", color: disabled ? "#475569" : "#fff",
    fontSize: "14px", fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.2s",
  }),
  error: {
    background: "#1a0a0a", border: "1px solid #7f1d1d", borderRadius: "6px",
    padding: "8px 12px", color: "#f87171", fontSize: "12px", marginBottom: "16px",
  },
  success: {
    background: "#0a1a0a", border: "1px solid #166534", borderRadius: "6px",
    padding: "8px 12px", color: "#4ade80", fontSize: "12px", marginBottom: "16px",
  },
  policy: { fontSize: "10px", color: "#475569", marginTop: "8px", lineHeight: "1.5" },
};

export default function LoginPage({ onLogin, onSetup }) {
  const [mode, setMode] = useState("login"); // "login" | "setup"
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSuccess(""); setLoading(true);
    try {
      if (mode === "setup") {
        const res = await onSetup(username, password);
        setSuccess(res.message || "Admin created. Please login.");
        setMode("login");
      } else {
        await onLogin(username, password);
      }
    } catch (err) {
      const msg = err.response?.data?.detail || err.message || "Login failed";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.title}>🛡️ SENTINEL BRAIN</div>
        <div style={s.sub}>
          {mode === "setup" ? "Create Admin Account" : "Autonomous Trading Infrastructure"}
        </div>

        {error && <div style={s.error}>{error}</div>}
        {success && <div style={s.success}>{success}</div>}

        <form onSubmit={handleSubmit}>
          <label style={s.label}>Username</label>
          <input
            style={s.input} type="text" value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username" autoFocus
          />

          <label style={s.label}>Password</label>
          <input
            style={s.input} type="password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === "setup" ? "new-password" : "current-password"}
          />

          {mode === "setup" && (
            <div style={s.policy}>
              Password policy: min 12 characters, uppercase, lowercase, digit, special character
            </div>
          )}

          <button style={s.btn(loading || !username || !password)} disabled={loading || !username || !password}>
            {loading ? "⏳ Please wait..." : mode === "setup" ? "Create Admin Account" : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
